module.exports = __webpack_public_path__ + "img/red-hat.59e8a7fc.svg";